import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { NotifyHelper } from './../../../helpers/toast';
import { eThangDiemActionTypeIds, IThangDiemActionTypes } from './../../action-types/so-diem/IThangDiemActions';
import { IThangDiemStateModel } from './../../page-state-model/so-diem/IThangDiemStateModel';
const iniState: IThangDiemStateModel = {
    status: ePageBaseStatus.is_not_initialization,
    thangDiems: []
}
export const thangDiemReducer = (state: IThangDiemStateModel = iniState, action: IThangDiemActionTypes): IThangDiemStateModel => {
    switch (action.type) {
        case eThangDiemActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eThangDiemActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                thangDiems: action.payload
            }
        case eThangDiemActionTypeIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                thangDiems: []
            }
        default:
            return {
                ...state
            }
    }
}